/** @deprecated use `HisOptionXtd` instead */
export class HisOption {
    label: string; // the label displayed to the user
    id: string; // the id;
    constructor( label?: string, id?: string ) {
        this.label = label;
        this.id = id;
    }
}
